import { useRef } from 'react';
import type { FC, PropsWithoutRef } from 'react';

import {
  Button,
  EmptyState,
  Flex,
  Grid,
  Icon,
  registerIcon,
  Text,
  useI18n
} from '@pega/cosmos-react-core';
import type { ForwardProps } from '@pega/cosmos-react-core';
import { StyledPageIcon } from '@pega/cosmos-react-core/lib/components/PageTemplates/PageTemplates';
import * as moveRightSolidIcon from '@pega/cosmos-react-core/lib/components/Icon/icons/move-right-solid.icon';
import * as moveLeftSolidIcon from '@pega/cosmos-react-core/lib/components/Icon/icons/move-left-solid.icon';

import type { EmailManagerProps } from './Email.types';
import {
  StyledEmailManagerContainer,
  StyledGridContainer,
  StyledHeader,
  StyledList
} from './Email.styles';

registerIcon(moveRightSolidIcon, moveLeftSolidIcon);

const EmailManager: FC<EmailManagerProps & ForwardProps> = ({
  header,
  list,
  emailCaseDetails,
  ...restProps
}: PropsWithoutRef<EmailManagerProps>) => {
  const headerRef = useRef<HTMLDivElement>(null);
  const t = useI18n();

  return (
    <StyledEmailManagerContainer {...restProps}>
      <Grid
        as={StyledGridContainer}
        container={{
          cols: 'minmax(20rem, 1fr) minmax(0, 3fr)',
          gap: 2
        }}
        item={{ area: 'container' }}
      >
        <Flex container={{ direction: 'column' }} as={StyledList}>
          {header && (
            <Flex
              container={{ alignItems: 'center', justify: 'between', pad: 2, gap: 1 }}
              as={StyledHeader}
              ref={headerRef}
            >
              <Flex container={{ alignItems: 'center', gap: 1 }}>
                {header.icon && (
                  <StyledPageIcon container={{ alignItems: 'center', justify: 'center' }}>
                    <Icon name={header.icon} />
                  </StyledPageIcon>
                )}
                <Text variant='h1'>{header.title}</Text>
              </Flex>

              {header.getNextEmail && (
                <Button
                  onClick={() => {
                    header?.getNextEmail?.();
                  }}
                >
                  {t('get_next_email')}
                </Button>
              )}
            </Flex>
          )}
          {list}
        </Flex>
        <div>{emailCaseDetails || <EmptyState />}</div>
      </Grid>
    </StyledEmailManagerContainer>
  );
};

export default EmailManager;
